import { ALL_SECONDARY_EVIDENCE_TYPES, SecondaryEvidenceType } from "../types/Evidence";

import EvidenceIndicator from "./EvidenceIndicator";
import GenderEvidenceIndicator from "./GenderEvidenceIndicator";

export default function SecondaryEvidenceList() {
    const regularEvidenceTypes = ALL_SECONDARY_EVIDENCE_TYPES.filter((next) => !isGender(next));

    const listItems = regularEvidenceTypes.map(evidenceType => {
        return (
            <li className="list-group-item" key={evidenceType}>
                <EvidenceIndicator evidenceType={evidenceType} />
            </li>
        );
    });

    return (
        <section className="card m-1 w-100">
            <header className="card-header">
                <h5 className="card-title">Secondary Evidence</h5>
            </header>
            <main>
                <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                        <GenderEvidenceIndicator />
                    </li>
                    {listItems}
                </ul>
            </main>
        </section>
    );
}

function isGender(type: SecondaryEvidenceType): boolean {
    return type === 'Male' || type === 'Female';
}
